import CustomError from "components/form/CustomError";
import { MultiSelect as PrimeMultiSelect } from "primereact/multiselect";

const MultiSelect = ({
  value,
  options,
  name = "name",
  placeholder = "Select",
  onChange,
  error = null,
  className = "",
  maxSelectedLabels = 2,
  label = null,
  hideError = false,
  required = null,
  appendTo = null,
}) => {
  return (
    <>
      {label && (
        <label>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}

      <PrimeMultiSelect
        value={value}
        options={options}
        onChange={(e) => onChange(e.value)}
        optionLabel="name"
        optionValue="value"
        placeholder={placeholder}
        display="comma"
        maxSelectedLabels={maxSelectedLabels}
        className={`custom_multiselect ${className}`}
        appendTo={appendTo}
      />
      {hideError ? null : <CustomError name={name} />}
    </>
  );
};

export default MultiSelect;
